import React from 'react';
import ComingSoon from '../../components/ComingSoon';

export default function WastageReports() {
    return <ComingSoon moduleName="Wastage Reports" description="Track wastage across all stages, identify cost impact, and improve processes." estimatedPhase="Phase 6 (Weeks 14-15)" priority="MEDIUM" />;
}
